import { AsyncPipe, TitleCasePipe } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  input,
  output,
  inject,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { NotFoundError } from '@fitness-force/models';
import type { STAFFINTERFACE } from '@fitness-force/models';

import { ErrorsComponent } from '@fitness-force/errors';
import { AssignedToComponent } from '@fitness-force/common/assigned-to';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { COMPANY_INFO } from '@fitness-force/state';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { PopoverModule } from 'primeng/popover';
import { StyleClassModule } from 'primeng/styleclass';
import { BehaviorSubject } from 'rxjs';
import { ToastMessageService } from '@fitness-force/api';

import { StaffService } from '@fitness-force/api';
import { environment } from '@fitness-force/environments';
import { AvatarModule } from 'primeng/avatar';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import { StaffStoreService } from '@fitness-force/api';

@Component({
  selector: 'change-reporting-manager',
  templateUrl: './change-reporting-manager.component.html',
  styleUrls: ['./change-reporting-manager.component.scss'],
  providers: [ToastMessageService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    ButtonModule,
    StyleClassModule,
    SelectModule,
    PopoverModule,
    ErrorsComponent,
    AvatarModule,
    ShortNamePipe,
    AssignedToComponent,
    TranslateModule,
    AsyncPipe,
    TitleCasePipe,
  ],
})
export class ChangeReportingManagerComponent implements OnInit {
  private fb = inject(UntypedFormBuilder);
  translate = inject(TranslateService);
  private store = inject(Store);
  private staffService = inject(StaffService);
  private toastMessageService = inject(ToastMessageService);
  private staffStoreService = inject(StaffStoreService);

  readonly changeReportingManagerDialog = input(false, { alias: 'visible' });
  readonly staff = input<STAFFINTERFACE>({} as STAFFINTERFACE);
  readonly closePopup = output({ alias: 'closePopup' });

  formGroup: UntypedFormGroup = new UntypedFormGroup({});
  reportToStaff$ = new BehaviorSubject({} as STAFFINTERFACE);
  updatedBy$ = new BehaviorSubject({} as STAFFINTERFACE);
  showErrorPopup = new BehaviorSubject(false);
  errorMessages = [] as any;

  constructor() {
    this.createForm();
  }

  ngOnInit(): void {
    this.ComponentInit();
  }

  createForm(): void {
    this.formGroup = this.fb.group({
      reporting_manager: new UntypedFormControl('', [Validators.required]),
    });

    this.formGroup.controls.reporting_manager.valueChanges.subscribe(
      (staff: STAFFINTERFACE) => {
        console.log(staff);
      },
    );
  }

  ComponentInit() {
    this.store.select(COMPANY_INFO).subscribe((responseData: any) => {
      this.translate.setDefaultLang(responseData?.selectedLang?.LANG_CODE);
      this.translate.use(responseData?.selectedLang?.LANG_CODE);
    });

    const staffValue = this.staff();
    if (staffValue?.reports_to_id) {
      this.staffStoreService
        .getStaffById(staffValue?.reports_to_id)
        .subscribe((staff: STAFFINTERFACE) => {
          this.reportToStaff$.next(staff);
          this.updatedBy$.next(staff);
        });
    }
    //   this.store.select(STAFF_STATE).subscribe((allStaff: STATE_STAFF_LIST) => {
    // const reportToStaff: STAFFINTERFACE | undefined =
    //       allStaff.staffListAll.find(
    //         (oStaff: STAFFINTERFACE) => oStaff.id ==  this.staff?.reports_to_id
    //       );
    //     if (reportToStaff) this.reportToStaff$.next(reportToStaff);

    //     const updatedByStaff: STAFFINTERFACE | undefined =
    //       allStaff.staffListAll.find(
    //         (oStaff: STAFFINTERFACE) => oStaff.id == this.staff?.reports_to_id
    //       );
    //     if (updatedByStaff) this.updatedBy$.next(updatedByStaff);
    //   });
  }

  ClosePopup(): void {
    this.closePopup.emit();
    this.formGroup.reset();
    this.closePopup.emit();
  }

  HideErrorPopup(event: any) {
    this.showErrorPopup?.next(false);
    this.errorMessages = [];
  }

  get ReportingManagerControl(): UntypedFormControl {
    return this.formGroup.controls.reporting_manager as UntypedFormControl;
  }

  ValidateAndSubmit(): void {
    if (this.formGroup.valid) {
      const staffId = this.staff().id;
      this.staffService
        .ChangeReportingManager(
          environment.BASE_URL,
          staffId,
          this.ReportingManagerControl.value.id,
        )
        .subscribe({
          next: (data: any) => {
            console.log(data);
            this.translate
              .get('common.message.record_updated')
              .subscribe((translation) => {
                this.toastMessageService.showSuccess(translation);
              });
            this.store.dispatch({ type: 'FETCH_STAFF_LIST' });
            this.ClosePopup();
          },
          error: (error: any) => {
            console.log(error, 'errororor');
            if (error instanceof NotFoundError) {
              this.errorMessages.push(error.originalError.error.errorMessage);
              this.showErrorPopup?.next(true);
            } else {
              if (error.originalError.status == 500) {
                this.errorMessages.push(error.originalError.error);
                this.showErrorPopup?.next(true);
              } else {
                if (Array.isArray(error.originalError.error)) {
                  error.originalError.error.forEach((e: any) => {
                    this.errorMessages.push(e.errorMessage);
                  });
                } else {
                  this.errorMessages.push(
                    error.originalError.error.errorMessage,
                  );
                }
                this.showErrorPopup?.next(true);
              }
            }
          },
        });
    }
  }
}
